export const FOXV3 = 'foxv3';
export const FOXPLAY = 'foxplay';
export const HBO = 'hbo';
export const CRACKLE = 'crackle';
export const PICARDIA = 'picardia';
export const TOOLBOX_MAP = {
    hbov2: true,
};

export const DASH_ENCODE = 'dash';
export const HLS_ENCODE = 'hls';

export const PLAY_READY_DRM = 'pr';
export const WIDEVINE_DRM = 'wv';
export const FAIR_PLAY_DRM = 'fp';
